<template>
    <div class="login container-fluid">
        <div class="login-container col-md-4 offset-md-4 col-10 mx-auto">
            <h3>SIGN IN</h3>
            <div class="form-group col-md-10 offset-md-1">
                <label class="form-label">Email</label>
                <input type="text" v-model="email" class="form-control">
            </div>
            <div class="form-group col-md-10 offset-md-1">
                <label class="form-label">Password</label>
                <input type="password" v-model="password" class="form-control">
            </div>

            <button @click="signIn" class="login-btn">Login</button>
        </div>
    </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "login",
  data: function() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    signIn: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.replace("admin");
          },
          err => {
            alert(err.message);
          }
        );
    }
  }
};
</script>

<style lang='scss' scoped>
body {
  background: url("/static/assets/img/register_bg.jpg") center no-repeat fixed;
  background-size: cover;
}

.login-container {
  margin: 10vh auto;
  box-shadow: 0 0 5px #ddd;
  padding: 15px 20px;
  text-align: center;
  background: #fff;
  border-radius: 5px;
}

.form-label {
    text-align: left;
    line-height: 36px;
    margin: 0;
    padding: 0px;
}

.form-group {
    padding: 0;
    margin-bottom: 0;
    text-align: left;
}

.form-control {
    border: 2px solid #232323;
    border-radius: 3px;
}

.login-btn {
    border: 2px solid #232323;
    padding: 4px 15px;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue